import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { MachinePartInfoData } from 'src/app/shared/services/machine-part-info.service';

@Component({
  selector: 'app-machine-part-info-detail',
  templateUrl: './machine-part-info-detail.component.html',
  styleUrl: './machine-part-info-detail.component.scss'
})
export class MachinePartInfoDetailComponent {
  private _unsubscriber = new Subject();

  @Input() id: string | undefined;

  constructor(
    private _mpSvc: MachinePartInfoData,
  ) {
  }

  ngOnInit(): void {
    this._mpSvc.LoadData(this.id ?? "");
  }

  ngOnDestroy(): void{
    this._unsubscriber.next(null);
    this._unsubscriber.complete();
  }

  public get MpSvc(): MachinePartInfoData{
    return this._mpSvc;
  }
}
